import React, { useState } from 'react';
import { seedListings } from '../scripts/seedListings';
import { useAuth } from '../contexts/AuthContext';

const SeedDatabase: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { currentUser } = useAuth();

  const handleSeed = async () => {
    if (!currentUser) {
      setMessage('✗ Error: You must be logged in to seed the database');
      return;
    }

    setLoading(true);
    setMessage('');
    
    try {
      await seedListings(currentUser.uid);
      setMessage('✓ Successfully seeded 5 listings to the database!');
    } catch (error: any) {
      setMessage(`✗ Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Database Seeding</h2>
      <p>Click the button below to add sample listings to the database.</p>
      
      <button
        onClick={handleSeed}
        disabled={loading}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          cursor: loading ? 'not-allowed' : 'pointer',
          backgroundColor: loading ? '#ccc' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          marginTop: '10px'
        }}
      >
        {loading ? 'Seeding...' : 'Seed Listings'}
      </button>
      
      {message && (
        <div style={{
          marginTop: '20px',
          padding: '15px',
          borderRadius: '4px',
          backgroundColor: message.startsWith('✓') ? '#d4edda' : '#f8d7da',
          color: message.startsWith('✓') ? '#155724' : '#721c24',
          border: `1px solid ${message.startsWith('✓') ? '#c3e6cb' : '#f5c6cb'}`
        }}>
          {message}
        </div>
      )}
      
      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
        <h3>Sample Listings to be Added:</h3>
        <ul style={{ lineHeight: '1.8' }}>
          <li>123 Main Street, San Francisco, CA 94102</li>
          <li>456 Oak Avenue, Los Angeles, CA 90012</li>
          <li>789 Pine Boulevard, San Diego, CA 92101</li>
          <li>321 Elm Court, Sacramento, CA 95814</li>
          <li>654 Maple Drive, San Jose, CA 95113</li>
        </ul>
        <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
          All listings will have status: <strong>pending</strong>
        </p>
        <p style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
          User ID: <strong>{currentUser?.uid || 'Not logged in'}</strong>
        </p>
      </div>
    </div>
  );
};

export default SeedDatabase;
